import { render } from "./ChartInfoFree.vue?vue&type=template&id=2d07aa6c&scoped=true"
import script from "./ChartInfoFree.vue?vue&type=script&lang=js"
export * from "./ChartInfoFree.vue?vue&type=script&lang=js"

import "./ChartInfoFree.vue?vue&type=style&index=0&id=2d07aa6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d07aa6c"]])

export default __exports__